{
  "dismiss": "تجاهل"
}